<template>
  <div>
    <swiper v-if='type==40' :items='items' :round='round' :shadow='shadow' />
    <div v-else :class="['items', 'flex-row', {'flex-between':type<40}]" :type='type'>
      <div v-for='(item,index) in items' :key="'iw'+ type +index" class='item' @click='goto(items[index].link)'>
        <img alt :src='item.image' :class="[{'round': round,'shadow':shadow}]" />
        <span v-if="item.title" class="two-line">{{item.title}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      type: {
        type: Number,
        required: true
      },
      round: {
        type: Boolean,
      },
      shadow: {
        type: Boolean,
        default: false
      },
      items: {
        type: Array,
        require: true,
      }
    },
  }
</script>

<style scoped>
  img {
    display: block;
    width: 100%;
    height: auto;
  }

  .round {
    border-radius: 10px;
  }

  .shadow {
    box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.09);
  }
  .items {
    font-size: 13px;
    color: #333;
    /* padding: 8px; */
    box-sizing: border-box;
  }
  .items[type='10'] .item {
    width: 100%;
  }

  .items[type='20'] .item {
    width: 50%;
  }

  .items[type='30'] .item {
    /* width: 33.3%; */
    flex: 1 1;
    text-align: center;
  }

  .items[type='50'] {
    color: #E83E3E;
    width: 100vw;
    padding:0 0 8px 0;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
  }

  .items[type='50'] .item {
    width: 42vw;
    min-width: 42vw;
    text-align: center;
  }

  .items[type='50'] .item+.item {
    margin-left:  10px;
  }
  .items[type='50'] .item:first-child {
    margin-left:  8px;
  }
  .items[type='50'] .item:last-child {
    padding-right: 8px;
  }
  .items .item>span {
    margin-top: 4px;
  }
</style>